import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountConsentsComponent } from './components/account-consents/account-consents.component';
import { AuthenticatedGuard } from '../auth/guards/authenticated.guard';
import { NoMaintenanceGuard } from '../core/guards/no-maintenance.guard';
import { AccountConsentsGuard } from './guards/account-consents.guard';

export const routes: Routes = [
  {
    canActivate: [NoMaintenanceGuard, AuthenticatedGuard, AccountConsentsGuard],
    component: AccountConsentsComponent,
    data: {
      toolbar: {
        title: 'Zmiana operatora',
      },
    },
    path: '',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class AccountConsentsRoutingModule {}
